<template>
  <div v-if="visible" class="confirm-overlay" @click.self="handleCancel">
    <div class="confirm-dialog" :class="type">
      <div class="confirm-icon">
        <i v-if="type === 'danger'" class="fas fa-exclamation-triangle"></i>
        <i v-else-if="type === 'warning'" class="fas fa-exclamation-circle"></i>
        <i v-else class="fas fa-question-circle"></i>
      </div>
      <div class="confirm-body">
        <div class="confirm-title">{{ title }}</div>
        <div class="confirm-message">{{ message }}</div>
      </div>
      <div class="confirm-footer">
        <button @click="handleCancel" class="btn btn-default btn-sm">取消</button>
        <button @click="handleConfirm" class="btn btn-sm" :class="btnClass" :disabled="loading">
          <i v-if="loading" class="fas fa-spinner fa-spin"></i>
          {{ loading ? '处理中...' : confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  visible: { type: Boolean, default: false },
  title: { type: String, default: '确认操作' },
  message: { type: String, default: '确定要执行此操作吗？' },
  confirmText: { type: String, default: '确认' },
  type: { type: String, default: 'primary', validator: v => ['primary', 'danger', 'warning'].includes(v) },
  loading: { type: Boolean, default: false }
})

const emit = defineEmits(['confirm', 'cancel', 'update:visible'])

const btnClass = computed(() => ({
  'primary': 'btn-primary',
  'danger': 'btn-danger',
  'warning': 'btn-warning'
})[props.type] || 'btn-primary')

const handleConfirm = () => emit('confirm')
const handleCancel = () => emit('cancel')
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.confirm-dialog {
  background: #fff;
  border-radius: 8px;
  padding: 28px 30px 20px;
  width: 420px;
  max-width: 90vw;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
}

.confirm-icon {
  text-align: center;
  font-size: 40px;
  margin-bottom: 12px;
}

.confirm-icon .fa-exclamation-triangle { color: #dc3545; }
.confirm-icon .fa-exclamation-circle { color: #ffc107; }
.confirm-icon .fa-question-circle { color: #1ab394; }

.confirm-body {
  text-align: center;
  margin-bottom: 20px;
}

.confirm-title {
  font-size: 17px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.confirm-message {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}

.confirm-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.btn-default {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  color: #374151;
}
.btn-default:hover { background: #e5e7eb; }

.btn-primary { background: #1ab394; border-color: #1ab394; color: #fff; }
.btn-primary:hover { background: #17a689; }

.btn-danger { background: #dc3545; border-color: #dc3545; color: #fff; }
.btn-danger:hover { background: #c82333; }

.btn-warning { background: #ffc107; border-color: #ffc107; color: #212529; }
.btn-warning:hover { background: #e0a800; }

.btn-sm {
  padding: 6px 20px;
  font-size: 13px;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
}
</style>
